export const isEmpty = (value) => {
    return value === undefined || value === null;
};
